<template>
  <CRow>
    <CCol lg="12">
      <CCard>
        <CCardHeader>
          <strong>Quản lý tính năng sản phẩm</strong>
          <div class="card-header-actions">
            <CButton v-if="allowCreate" type="button" shape="pill" color="info" @click="createNew">
              <CIcon name="cil-plus"/>
              Thêm mới</CButton>
          </div>
        </CCardHeader>
        <CCardBody class="pt-0">
          <CDataTable
            :items="licenses"
            :fields="fields"
            :tableFilter="{label :'Bộ lọc: ', placeholder:'Nội dung' }"
            :itemsPerPageSelect="{label:' '}"
            column-filter
            sorter
            pagination
          >
            <template #no-items-view>
              <div style="color: #888; text-align: center; padding: 10px; font-style: italic;">
                Danh sách trống!
              </div>
            </template>
            <template #actions="{item}">
              <td class="py-2">
              <CButton
                type="button"
                shape="pill"
                color="info"
                variant="outline"
                size="sm"
                @click="editRecord(item)"
                @dblclick="editRecord(item)"
              >
                  <CIcon name="cil-pencil"/>
              </CButton>
              </td>
            </template>


            <template #lic_key="{item}">
              <td class="py-2">
                <CTextarea
                  :wrapperClasses="'no-border'"
                  v-model="item.lic_key"
                  rows="2"
                />
              </td>
            </template>

            <template #stt="{item, index}">
              <td class="py-2">
                {{index+1}}
              </td>
            </template>

          </CDataTable>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>

export default {
  data() {
    return {
      allowCreate: false,
      // Define the table fields
      fields: [
        { key: 'stt', label: 'Stt', _style:'width:3rem;' },
        { key: 'lic_uid', label: 'Unique ID' , _classes: 'font-weight-bold' },
        { key: 'name', label: 'Product' },
        { key: 'uuid', label: 'Seri',},
        { key: 'lic_key', label: 'License Key' , _style:'width:30%'},
        { key: 'lic_status', label: 'Status' },
        { key: 'lic_expired', label: 'Expiration Date' },
        { key: 'lic_features', label: 'Features' },
        // { key: 'issue', label: 'Issued Date' },
        { key: 'actions', label: 'Actions' },
      ],
      licenses: [
      ],
    };
  },
  created() {
    this.getAll()
  },
  methods: {
    getAll() {
      this.$request.get('/api/device/licenses')
        .then(res=>{
          // console.log(res.data)
          this.licenses=res.data.licenses
        })
    },
    editRecord(item) {
      // console.log('Edit record:', item.id);
      this.$router.push({
        path: '/device/licedit',
        query: {
          id: item.id
        }
      })
    },
    createNew() {
      // console.log('Creation new New');
      this.$router.push({
        path: '/device/licedit'
      });
    },
  },
};
</script>

<style scoped>
/* Custom style to remove the border */
.no-border {
  border: none !important;
  outline: none; /* Optional: Prevent focus outline */
  background-color: transparent; /* Optional: Make the background transparent */
}
</style>
